import axios from "axios";
import React, { useState, useEffect } from "react";
import { Client } from "../components/client";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const API_URL = process.env.REACT_APP_API_URL;

  const [clients, SetClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Search
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredClients, setFilteredClients] = useState(clients);
  // Pagination settings
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 10;
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = filteredClients.slice(itemOffset, endOffset);
  const totalPages = Math.ceil(filteredClients.length / itemsPerPage);
  // Navigation
  const navigate = useNavigate();

  const handlePlusBtn = () => {
    navigate("/addClient");
  };

  const handleLogoutBtn = () => {
    localStorage.removeItem("authToken");
    sessionStorage.removeItem("authToken");
    navigate("/logout");
  };
  const handlePageChange = (event) => {
    const newOffset = (event.selected * itemsPerPage) % clients.length;
    setItemOffset(newOffset);
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    if (query === "") {
      setFilteredClients(clients);
    } else {
      const filtered = clients.filter(
        (client) =>
          client.name.toLowerCase().includes(query.toLowerCase()) ||
          client.contact.toLowerCase().includes(query.toLowerCase()) ||
          client.email.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredClients(filtered);
    }
  };

  useEffect(() => {
    axios
      .get(`${API_URL}/clients`)
      .then((response) => {
        SetClients(response.data);
        const temp = response.data.sort((a, b) => a.id - b.id);
        setFilteredClients(temp);
        setLoading(false);
      })
      .catch((error) => {
        setError(error.message);
        setLoading(false);
      });
  }, [API_URL]);
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error: {error}</div>;
  }
  return (
    <div className="min-h-screen flex flex-col items-center bg-[#545454] pb-16">
      <title>Dashboard | HairBank</title>

      <div className="flex w-4/5 items-end text-center">
        <div className="w-full">
          <h1 className="text-[#eed495] text-6xl mt-16 xl:mt-5 w-full">
            Member Page
          </h1>
        </div>
        <div className="flex w-2 text-2xl bg-gray-600 text-[#eed495] justify-end">
          <button className="hover:text-white" onClick={handleLogoutBtn}>
            SignOut
          </button>
        </div>
      </div>

      <div className="mt-10 text-2xl w-full flex justify-center items-center">
        <span className="text-white mr-4">FIND</span>
        <input
          className="bg-[#545454] border-2 text-[#eed495] rounded-md w-1/5"
          type="text"
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder={`Search Client`}
        />
      </div>

      <div className="w-11/12 flex justify-end mb-4">
        <button
          className="text-3xl text-[#eed495] border-2 mt-2 w-14 text-center hover:text-white"
          onClick={handlePlusBtn}
        >
          +
        </button>
      </div>

      <table className="w-11/12 mb-10">
        <thead>
          <tr className="text-white font-semibold text-xl w-3/4 border-2 border-collapse">
            <th>Name</th>
            <th>Contact</th>
            <th>Email</th>
            <th>Membership</th>
            <th>Balance</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((client) => (
            <Client client={client} key={client.id} />
          ))}
        </tbody>
      </table>

      <ReactPaginate
        className="w-auto flex text-center mt-10 text-3xl text-[#eed495]"
        disabledClassName="text-white"
        pageClassName="w-10"
        activeClassName="text-white"
        breakLabel="..."
        breakClassName="w-10"
        nextLabel="Next"
        nextClassName="w-18 ml-4"
        onPageChange={handlePageChange}
        pageRangeDisplayed={5}
        pageCount={totalPages}
        previousClassName="w-32 mr-4"
        previousLabel="Previous"
        renderOnZeroPageCount={null}
      />
    </div>
  );
}

export default Dashboard;
